export enum SecurityAction {
  Users = 'users',
  Groups = 'groups',
  IPAccesses = 'ipaccess',
  IpAddressAdd = 'ipaccess_add',
  IpAddressEdit = 'ipaccess_edit',
  IpAddressDelete = 'ipaccess_delete',
}

export enum FirewallAction {
  View = 'view',
  Add = 'add',
  Delete = 'delete',
}
